import React from "react";
import SuggestedFollows from "../../components/SuggestedFollow";
import LatestNews from "../../components/LatestNews";
import ClubList from "../../components/ClubList";


function Clubs() {
  return (
    <div className="right-panel-inner">
        <div className="post-section">
            <h2 className="mb-20">Clubs</h2>
            <ClubList/>
        </div>
        <div className="right-side-bar">
          <LatestNews/>
          <SuggestedFollows/>
        </div>
    </div>
  );
}

export default Clubs;